import { render, staticRenderFns } from "./SpecialistList.vue?vue&type=template&id=f6fc4e32&scoped=true&"
import script from "./SpecialistList.vue?vue&type=script&lang=js&"
export * from "./SpecialistList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fc4e32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
